module.exports = __webpack_public_path__ + "static/protect-asset-poster-f3a15c7d0ddb6b6d2ee05ae4a846fc62.jpg";